import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable, lastValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';

export const openDialogGetResult = <T extends unknown, C = any>(dialog: MatDialog, component: any, config?: MatDialogConfig): Promise<T> => lastValueFrom(dialog.open(component, config).afterClosed())

export const transformObservableToSinglePromise = <T extends unknown>(observable: Observable<any>): Promise<T> => new Promise((resolve, reject) => observable.pipe(take(1)).subscribe(data => resolve(data), error => reject(error)))
